import { useEffect, useRef } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AuthLayout } from '../components/AuthLayout'
import { ButtonLink, Spinner } from '../components/ui'
import { api, call } from '../lib/api'
import { meQuery } from '../lib/queries'

export const Route = createFileRoute('/verify')({
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({ token: typeof s.token === 'string' ? s.token : undefined }),
  component: Verify,
})

function Verify() {
  const { token } = Route.useSearch()
  const qc = useQueryClient()
  const verify = useMutation({
    mutationFn: () => call(api.POST('/auth/verify', { body: { token: token ?? '' } })),
    onSuccess: () => qc.invalidateQueries({ queryKey: meQuery.queryKey }),
  })
  // The link is single-use, so confirm exactly once even under StrictMode's
  // double-invoked effects.
  const fired = useRef(false)
  useEffect(() => {
    if (token && !fired.current) {
      fired.current = true
      verify.mutate()
    }
  }, [token, verify])

  if (verify.isSuccess) {
    return (
      <AuthLayout title="Email confirmed" lede="Thanks. Password resets and round reminders will reach you here.">
        <ButtonLink to="/" variant="primary" block>Back to the league</ButtonLink>
      </AuthLayout>
    )
  }
  if (!token || verify.isError) {
    return (
      <AuthLayout title="That link has expired" lede="Confirmation links work once. You can send yourself a new one from your account page.">
        <ButtonLink to="/account" variant="primary" block>Go to your account</ButtonLink>
      </AuthLayout>
    )
  }
  return (
    <AuthLayout title="Confirming…"><span className="text-muted"><Spinner /></span></AuthLayout>
  )
}
